import React from 'react'

import SharedTopPicks from '@/components/shared/top-picks'
import type { ProductionListData } from '@/context/productions-list/types'
import { PageType } from '@/types/app-types'
import { ClickLocation } from '@/utils/analytics/types'

import styles from './styles.module.scss'

interface VenueTopPicksBlock {
    venueTopPickProductions?: ProductionListData
}

const VenueTopPicksBlock: React.FC<VenueTopPicksBlock> = ({ venueTopPickProductions }) => {
    const isValidProductionList = venueTopPickProductions?.items && venueTopPickProductions.items.length > 1
    if (!isValidProductionList) return <></>
    return (
        <SharedTopPicks
            shouldShowLoader={false}
            productions={venueTopPickProductions?.items}
            title="Top Picks"
            desktopHasFindMoreEventsLink={false}
            hideVenue
            shouldShowUserLocation={false}
            classes={styles}
            trackingClickLocation={ClickLocation.VENUE_PAGE_TOP_PICKS}
            trackingPageType={PageType.Venue}
        ></SharedTopPicks>
    )
}

export default VenueTopPicksBlock
